// extracted by extract-css-chunks-webpack-plugin
module.exports = {"timerClockDigitInner":"_3Dj17","timerFlip":"_5Zm3W","timerPrevNumber":"Qxhrw","timerNextNumber":"x5G4D","timerDayLeftStyle":"mZaN-","timerDayTextStyle":"_3DP9v"};